import { render, staticRenderFns } from "./IconProsegur.vue?vue&type=template&id=68d0cfe0"
import script from "./IconProsegur.vue?vue&type=script&lang=ts"
export * from "./IconProsegur.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports